/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { IVCSStrictHttpResponse } from '../../ivcs-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ConsumerPharmacistVerifiedGet$Plain$Params {
}

export function consumerPharmacistVerifiedGet$Plain(http: HttpClient, rootUrl: string, params?: ConsumerPharmacistVerifiedGet$Plain$Params, context?: HttpContext): Observable<IVCSStrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, consumerPharmacistVerifiedGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as IVCSStrictHttpResponse<boolean>;
    })
  );
}

consumerPharmacistVerifiedGet$Plain.PATH = '/Consumer/PharmacistVerified';
